<template>
  <section :class="[{'text-left border-t border-neutral-200 mt-10' : !first}, 'text-left']">
    <UiHeadline v-if="$slots.title" type="div" design="h3" :class="[{'mt-10' : !first}, 'mb-6']">
      <slot name="title" />
    </UiHeadline>
    <template v-if="$slots.content">
      <slot name="content" />
    </template>
  </section>
</template>

<script setup lang="ts">
const props = defineProps({
  position: {
    type: String,
    default: null
  }
})

const first = computed(() => props.position === 'first')
</script>

